define('models/t1AppDashboard',["Underscore", "T1", "T1Model", "T1Comm"], function (_, T1, T1Model, T1Comm) {
  "use strict";

  T1.Models.T1AppsDashboard = T1Model.extend({
    apiRoot: T1.API_APPS_ROOT,
    dataType: "json",
    url: "",
    fetch: function (options) {
      var self = this;
      return T1Comm.get({
        dataType: "json",
        processAjaxResponse: self.processAjaxResponse,
        onStatusInvalid: function (e) {
          T1.log(e, "status");
        },
        onSuccess: options.success,
        onError: function (e) {
          T1.log(e);
        },
        sourceURL: T1.API_APPS_ROOT + "v1.0/organizations/apps?start_date=" + options.startDate + "&end_date=" + options.endDate
      });
    },
    processAjaxResponse: function (resp) {
      return {
        jsonData: resp,
        statusCode: "ok"
      };
    }
  });
  return T1.Models.T1AppsDashboard;
});
